<template>
  <div class="section">
    <!-- 中建八局管培生报告【首页】 -->
    <img :src="images.logo" class="report-logo" />

    <!-- 报告名称 -->
    <div class="report-info">
      <p align="center" class="report-name">
        {{ this.model.ent_name }}
      </p>
      <p align="center" class="report-type">
        <b>{{ this.model.report_type == '3' ? "&nbsp;":  this.model.report_type}}</b>
      </p>
    </div>

    <!-- 基础信息 -->
    <div class="base_info">
      <p class="base_info_name">
        {{ this.model.realName }}
      </p>

      <p class="base_info_gender">
        <span style="margin-right: 30px">
          {{ this.model.gender || "性别未知" }}
        </span>
        <el-divider direction="vertical"></el-divider>

        <span style="margin-left: 20px" v-if="this.model.age">
          {{ this.model.age }}岁</span>
        <span style="margin-left: 20px" v-else>
          年龄不详</span>
      </p>
    </div>

    <!-- 详细信息 -->
    <div class="more_info">
      <table width="150" height="272" class="more-info-table">
        <tbody>
          <!-- 此处排版要按5个元素的高度设置 -->
          <tr v-for="(item, index) in this.infoList" :key="index">
            <td style="
                font-size: 14pt;
                color: #6e736e;
                font-weight: bold;
                width: 100px;
              ">
              <div>
                {{ item.name }}
              </div>
            </td>
            <td style="
                font-size: 17pt;
                font-weight: bold;
                max-width: 300px;
                overflow: hidden;
                text-overflow: ellipsis;
                text-algin: left;
              ">
              <div>
                {{ item.value }}
              </div>
            </td>
          </tr>

          <tr class="email" v-if="email">
            <td class="trLeft">
                <div>
                    邮箱
                </div>
            </td>
            <td class="trRight">
              <email-model v-if="email" :email="email" :guid="guid" :privacyType="privacyType"></email-model>
            </td>
          </tr>
          <tr class="Mobile" v-if="mobile">
            <td class="trLeft">
                <div>
                    电话
                </div>
            </td>
            <td class="trRight">
                <mobile-model v-if="mobile" :mobile="mobile" :guid="guid" :privacyType="privacyType"></mobile-model>
            </td>
          </tr>
          <tr class="idcard" v-if="idcard">
            <td class="trLeft">
                <div>
                    身份证号码
                </div>
            </td>
            <td class="trRight">
                <idcard-model v-if="idcard" :idcard="idcard" :guid="guid" :privacyType="privacyType"></idcard-model>
            </td>
          </tr>

          <tr>
            <td class="table-name">测评日期</td>
            <td class="table-info">
              {{ this.model.report_time }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- 声明 -->
    <div class="statement">
      <div v-html="statement"></div>
    </div>
  </div>
</template>

<script>
import { AllInfo } from "@/views/report/config/four";
import EmailModel from '../components/email-model.vue'
import MobileModel from '../components/mobile-model.vue'
import IdCardModel from '../components/idcard-model.vue'

export default {
  components: {
    EmailModel,
    MobileModel,
    IdCardModel
  },
  props: ["model", "baseInfo", "info", 'guid', 'privacyType'],
  data() {
    return {
      infoList: [],
      images: {
        logo: require("../../../assets/images/page1/logo.png"),
      },
      statement: AllInfo.statement,

      email: '',
      mobile: '',
      idcard: '',
    };
  },
  mounted() { },
  watch: {
    info(val) {
      if (val && val.length > 0) {
        this.infoList = []
        let _this = this;
        this.info.forEach(function (item) {
          if (item.name == '邮箱') {
            _this.email = item.value
          }
          else if (item.name == '电话') {
            _this.mobile = item.value
          }
          else if (item.name == '身份证号码') {
            _this.idcard = item.value
          }
          else {
            _this.infoList.push(item)
          }
        })
      }
      else {
        this.infoList = []
      }
    }
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.section {
  page-break-before: always;
  page-break-after: always;
  page-break-inside: avoid;
  background-size: cover;
  background-image: url("../../../assets/images/page1/background.png");
  height: 1124px;
  overflow: hidden;

  .report-logo {
    height: auto;
    width: 20%;
    float: right;
    margin-right: 50px;
    margin-top: 30px;
  }

  .report-info {
    margin-left: 290px;
    padding-top: 170px;

    .report-name {
      text-align: center;
      font-size: 33pt;
      color: white;
      padding: 10px;
      font-weight: bold;
    }

    .report-type {
      text-align: center;
      font-size: 33pt;
      color: white;
    }
  }

  .base_info {
    margin-left: 100px;

    .base_info_name {
      font-size: 40px;
      margin-top: 80px;
      font-weight: bold;
    }

    .base_info_gender {
      font-size: 17pt;
      margin-top: 15px;
      font-weight: 600;
    }
  }

  .more_info {
    margin-top: 80px;
    margin-left: 70px;
    min-height: 391px;

    .more-info-table {
      width: 400pt;
      border-collapse: separate;
      border-spacing: 30px;

      .table-name {
        font-size: 14pt;
        color: #6e736e;
        font-weight: bold;
        width: 100px;
      }

      .table-info {
        font-size: 17pt;
        font-weight: bold;
      }
    }
  }

  .statement {
    padding: 30px 60px 30px 60px;
    color: #6d796d;
    font-size: 16.5px;
    line-height: 24px;
  }


}
.trLeft {
    font-size: 14pt;
    color: #6e736e;
    font-weight: bold;
    width: 100px;
}

.trRight {
    font-size: 17pt;
    font-weight: bold;
    max-width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
    text-algin: left;
}

</style>



// WEBPACK FOOTER //
// src/views/report/four/pageOne.vue